import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { API_BASE } from '#api/client.js'
import { useFetch } from '#hooks/useAdminResource.js'

export const RequireAuth = () => {
  const { data, isLoading } = useFetch<{ email: string; name?: string }>(
    'auth/me',
    {},
  )

  const isUnauthenticated = !isLoading && !data?.email

  useEffect(() => {
    if (isUnauthenticated) {
      const returnTo = `${window.location.pathname}${window.location.search}`
      window.location.href = `${API_BASE}/auth/login?returnTo=${encodeURIComponent(returnTo)}`
    }
  }, [isUnauthenticated])

  if (isLoading || isUnauthenticated) {
    return (
      <div className="min-h-screen bg-base-200 flex items-center justify-center">
        <div className="loading loading-spinner loading-lg text-primary" />
      </div>
    )
  }

  return <Outlet />
}
